import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox
} from '@mui/material'
import { withTranslation } from 'react-i18next'

function ComplianceEditDialog({ t, open, compliance, onClose, onSave }) {
  const [editCompliance, setEditCompliance] = useState({})

  useEffect(() => {
    setEditCompliance({ notify_client: false, ...compliance })
  }, [compliance])

  if (!editCompliance) return null

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('edit_compliance')}</DialogTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 3, minWidth: 400 }}
      >
        <TextField
          select
          id='status'
          label={t('Status')}
          value={editCompliance.status || ''}
          onChange={(e) =>
            setEditCompliance({ ...editCompliance, status: e.target.value })
          }
          sx={{ mt: 2 }}
        >
          <MenuItem value='pending'>{t('Pending')}</MenuItem>
          <MenuItem value='complete'>{t('Complete')}</MenuItem>
          <MenuItem value='expired'>{t('Expired')}</MenuItem>
        </TextField>

        <TextField
          id='due_date'
          label={t('Due Date')}
          type='date'
          InputLabelProps={{ shrink: true }}
          value={
            editCompliance.due_date && !isNaN(new Date(editCompliance.due_date))
              ? new Date(editCompliance.due_date).toISOString().split('T')[0]
              : ''
          }
          onChange={(e) =>
            setEditCompliance({ ...editCompliance, due_date: e.target.value })
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={!!editCompliance.notify_client}
              onChange={(e) =>
                setEditCompliance({ ...editCompliance, notify_client: e.target.checked })
              }
            />
          }
          label={t('notify_client_of_change')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Cancel')}</Button>
        <Button onClick={() => onSave(editCompliance)}>{t('Save')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default withTranslation()(ComplianceEditDialog)
